import { Directive, HostBinding, Input, Renderer2, ElementRef } from '@angular/core';

enum RowHighlightColor {
    primary = 'primary',
    secondary = 'secondary',
    tertiary = 'tertiary',
    success = 'success',
    danger = 'danger',
    warning = 'warning',
    info = 'info',
}

@Directive({
    selector: '[ui-table-row]',
    standalone: false
})
export class UiTableRowDirective {
    @Input() invalid = false;
    @Input() disabled = false;

    private _highlight = false;
    private _highlightColor: keyof typeof RowHighlightColor = 'primary';
    private _currentHighlightClass: string | null = null;

    constructor(private renderer: Renderer2, private el: ElementRef<HTMLElement>) {}

    @Input()
    set highlight(value: boolean) {
        this._highlight = !!value;
        this.updateHighlightClass(this._highlightColor);
    }
    get highlight(): boolean {
        return this._highlight;
    }

    @Input()
    set highlightColor(value: keyof typeof RowHighlightColor) {
        const color = (value || 'yellow') as keyof typeof RowHighlightColor;
        this._highlightColor = color;
        this.updateHighlightClass(color);
    }
    get highlightColor(): keyof typeof RowHighlightColor {
        return this._highlightColor;
    }

    @HostBinding('class.ui-table-row')
    get isApplied() {
        return true;
    }

    @HostBinding('class.ui-table-row__disabled')
    get isDisabled(): boolean {
        return this.disabled;
    }
    @HostBinding('class.ui-table-row__invalid')
    get isInvalid(): boolean {
        return this.invalid;
    }

    @HostBinding('class.ui-table-row__highlight')
    get isHighlighted(): boolean {
        return this._highlight;
    }

    private updateHighlightClass(color: string) {
        // Remove antiga se for diferente
        if (this._currentHighlightClass && this._currentHighlightClass !== color) {
            this.renderer.removeClass(this.el.nativeElement, this._currentHighlightClass);
            this._currentHighlightClass = null;
        }

        // Se está em highlight, adiciona a classe desejada
        if (this._highlight) {
            if (this._currentHighlightClass !== color) {
                this.renderer.addClass(this.el.nativeElement, color);
                this._currentHighlightClass = color;
            }
        } else {
            // se não está em highlight, remove qualquer classe de highlight
            if (this._currentHighlightClass) {
                this.renderer.removeClass(this.el.nativeElement, this._currentHighlightClass);
                this._currentHighlightClass = null;
            }
        }
    }
}
